module.exports = __webpack_public_path__ + "img/climate-smart-vineyard.223c5612.jpg";